// extracted by mini-css-extract-plugin
export default {"mainWrapper":"consolidation_mainWrapper__DZYwn","actionButtons":"consolidation_actionButtons__b3R-J"};